import { loadQuizNumber, loadResult } from "actions/quiz";
import React, { useEffect, useState, useCallback } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import "./AssessmentsResults.css";
import { markActivityComplete } from "actions/dataLoad";
import { useUserInfoSelector, useUserTokenSelector } from "store/reducers";
import { useDispatch } from "react-redux";
import { setUserCoins, startLoading, stopLoading } from "store/actions";
import { MdArrowBackIos } from "react-icons/md";
import blissWithBook from "assets/svg_icons/blissWithBook.svg";
import blissWithBoy from "assets/svg_icons/blissWithBoy.svg";
import yogaGirl from "assets/svg_icons/yogaGirl.svg";

const waitMessages = [
  `That was honest and brave! Thanks for showing up
for yourself.
Your results are ready`,

  `That’s it! You showed up for yourself today.

Small check-ins like this help you understand what’s going on inside.
Keep going — you're doing better than you think`,

  `You faced your thoughts with courage. Whatever your score, know that awareness is progress.

Let’s explore what you need next.`
];

const AssessmentsResults = () => {
  const { urlSlug } = useParams();
  const userToken = useUserTokenSelector();
  const userInfo = useUserInfoSelector();
  const [quizNotFound, setQuizNotFound] = useState(false);
  const [result, setResult] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const [error, setError] = useState("");
  const history = useHistory();
  const { activityId } = location?.state || {};
  const queryString = location?.search || "";
  const params = new URLSearchParams(queryString);
  const sum = params.get("sum");

  const [showResults, setShowResults] = useState(false);
  const [waitText, setWaitText] = useState("");

  const activityComplete = useCallback(
    async (activityIdToComplete) => {
      try {
        const response = await markActivityComplete(
          userToken,
          userInfo.id,
          activityIdToComplete
        );
        const { status, error, coinsBalance } = response.data;
        if (status !== "success") throw new Error(error);
        if (coinsBalance) dispatch(setUserCoins(coinsBalance));
      } catch (error) {
        console.error("Failed to complete activity: ", error.message);
      }
    },
    [userToken, userInfo, dispatch]
  );

  useEffect(() => {
    const fetchResults = async () => {
      try {
        dispatch(startLoading());
        const quiz = await loadQuizNumber(urlSlug, userToken)
          .catch(() => { setQuizNotFound(true); return null; });
        const quizNo = quiz ? Number(quiz.data.number) : null;
        if (quizNo === null || sum === null) {
          setError("Quiz information is missing or invalid.");
          return;
        }

        const res = await loadResult(quizNo, sum, userToken);
        if (activityId) activityComplete(activityId);
        setResult({ ...res.data.submitQuiz });

        // 👉 pick a random wait message and start timer
        const randomMsg = waitMessages[Math.floor(Math.random() * waitMessages.length)];
        setWaitText(randomMsg);
        setTimeout(() => setShowResults(true), 5000);
      } catch (err) {
        console.error("Error fetching assessment results:", err);
        if (err?.response?.data?.redirectToSignIn) {
          setError(err.response.data.error);
          setTimeout(
            () =>
              history.push({
                pathname: "/signin",
                state: { referer: location.pathname },
              }),
            3000
          );
        } else {
          setError(err?.response?.data?.error || "An unknown error occurred");
        }
      } finally {
        dispatch(stopLoading());
      }
    };

    fetchResults();
  }, [
    urlSlug,
    sum,
    userToken,
    activityId,
    dispatch,
    history,
    location.pathname,
    activityComplete,
  ]);

  console.log(result)

  return (
    <>
      {error && <div className="error-message">{error}</div>}

      {result && !showResults && (
        /* ---------- Waiting screen ---------- */
        <div className="intro-screen">
          <img src={blissWithBook} alt="bliss" className="bliss-img" />
          <div className="intro-text">
            {waitText.split("\n").map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        </div>
      )}

      {result && showResults && (
        /* ---------- Actual results ---------- */
        <div className="container-result">
          <div onClick={() => history.push("/dashboard/assessments")}>
            <MdArrowBackIos className="back-icon" />
          </div>
          <div className="main-container-result">
            <div>
              <h4 style={{ marginBottom: "10px" }}>
                <b>{result.interpretation}</b>
              </h4>
            </div>
            <h5>{result.shortInterpretation}</h5>
            {/* <h5>{result.identifier}</h5> */}
            <h5>Here's something for you:</h5>
            <div className="buttons-results">
              <button
                className="next-btn active"
                onClick={() => history.replace("/dashboard/sessionBooking")}
              >
                Book a Session
              </button>
              <button
                className="next-btn"
                onClick={() => history.replace("/dashboard/analytics")}
              >
                Go to Home
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssessmentsResults;
